import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';
import { defaultsDeep, map, set } from 'lodash';

interface InputProps extends FormlyFieldProps {
  fields: FormlyFieldConfig[];
}

@Component({
    selector: 'lockton-apps-intro-type',
    templateUrl: './card-type.component.html',
    styleUrls: ['./card-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CardTypeComponent extends FieldType<FieldTypeConfig<InputProps>> {
  fields: FormlyFieldConfig[] = [];

  ngOnInit(): void {
    this.fields = map(this.field.props.fields, (field: FormlyFieldConfig) =>
      defaultsDeep(
        { defaultValue: this.field.defaultValue[field.key as string] },
        field
      )
    );
  }

  onModelChange(data: unknown): void {
    this.formControl.setValue(data, { emitEvent: false });
    this.form.updateValueAndValidity();
    set(this.model, `${this.key}`, this.formControl.value);
  }
}
